import React from "react";
import { Gem, Lock, Truck, Users, BoxIcon } from "lucide-react";
import { trustItems } from "../../data/blackout";
import { TrustIcon } from "../../types/blackout";
const icons: Record<TrustIcon, BoxIcon> = {
  shipping: Truck,
  secure: Lock,
  quality: Gem,
  crew: Users
};
export function TrustBar() {
  return <section aria-label="Why shop with us" className="border-y border-gunmetal/60 bg-carbon" data-id="element-349" data-mp="3nydnl8y8ylk7">
      <ul className="mx-auto grid max-w-7xl grid-cols-2 gap-y-6 px-5 py-8 md:grid-cols-4 md:px-8" data-id="element-350" data-mp="3rzp85029kglj">
        {trustItems.map(item => {
        const Icon = icons[item.icon];
        return <li key={item.title} className="flex items-center gap-3 md:justify-center" data-id="element-351" data-mp="5rz28oxnf9bs">
              <Icon className="h-7 w-7 shrink-0 text-bone" strokeWidth={1.5} aria-hidden="true" data-id="element-352" data-mp="aqshalsl38e2" />
              <div data-id="element-353" data-mp="27j2efin6svyg">
                <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-bone" data-id="element-354" data-mp="27ju82nx84jm3">
                  {item.title}
                </p>
                <p className="mt-0.5 text-[11px] uppercase tracking-[0.12em] text-steel" data-id="element-355" data-mp="2cif6chsx0t7w">
                  {item.detail}
                </p>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}